import React, { Component } from "react";

import { getWizardData } from "../services/db";

import { checkParams, newSearchURL } from "./../components/Utils";

import Header from "./layout/Header";

import Features from "./layout/Features";

import StepColor from "./step/StepColor";
import StepOptions from "./step/StepOptions";
import StepCustomPackage from "./step/StepCustomPackage";
import { PageView, initGA, Event } from "./Utils/index";

export class Home extends Component {
  state = {
    steps: null,
    wizardData: null
  };

  componentDidMount() {
    const { match } = this.props;

    const wizardData = getWizardData(match);

    if (wizardData) {
      wizardData
        .then(data => {
          const steps = data && data.steps;

          this.setState({
            steps,
            wizardData: data
          });
        })
        .catch(error => {
          console.log("Error getting wizard data", error);
        });
    }
    initGA("UA-158191807-1");
    PageView();
  }

  handleStepParam = stepParamURL => {
    const { history, location } = this.props;
    const { pathname } = location;

    const checkIfParamExist =
      location && checkParams(`step${parseInt(stepParamURL) + 1}`, location);

    const newURL = newSearchURL(
      `step=${stepParamURL}`,
      `step=${parseInt(stepParamURL) + 1}`,
      location
    );

    let nextStep = `${pathname}${newURL}`;
    if (!checkIfParamExist) {
      nextStep = `${pathname}${newURL}&step${parseInt(stepParamURL) + 1}=empty`;
    }

    history.push(nextStep);
  };

  render() {
    const { match, history, location } = this.props;
    const { steps, wizardData } = this.state;
    const stepParamURL = location && checkParams("step", location);
    const stepIndex = stepParamURL ? parseInt(stepParamURL) - 1 : 0;
    

    if (!match) return;
    return (
      <div>
        {wizardData && (
          <Header wizardData={wizardData} match={match} location={location} />
        )}
        <section
          className="wizard-main-wrapper"
          style={
            wizardData && {
              backgroundImage: `url(${wizardData.backgorund_image})`
            }
          }
        >
          <div className="container p-0">
            <div
              className={
                (steps && stepIndex === 0) ||
                (steps && stepIndex === steps.length)
                  ? ""
                  : "row mg-left-0 mg-right-0"
              }
            >
              <div
                className={
                  (steps && stepIndex === 0) ||
                  (steps && stepIndex === steps.length)
                    ? ""
                    : "col-12 col-md-6 p-0"
                }
              >
                {steps && stepIndex < steps.length && (
                  <div>
                    <StepColor
                      match={match}
                      history={history}
                      location={location}
                      stepIndex={stepIndex}
                    />
                  </div>
                )}
              </div>

              <div
                className={
                  steps && stepIndex === steps.length
                    ? ""
                    : "col-12 col-md-6 bg-white mb-md-4"
                }
              >
                <div
                  className={
                    steps && stepIndex > 0 && stepIndex < steps.length
                      ? " min-scroll"
                      : ""
                  }
                >
                  <div
                    className={
                      steps && stepIndex > 0 && stepIndex < steps.length
                        ? "wizard-col-m-steps"
                        : ""
                    }
                  >
                    {steps && stepIndex === steps.length && (
                      <div className="custom-package">
                        <StepCustomPackage
                          props={this.props}
                          match={match}
                          history={history}
                          location={location}
                          stepParamURL={stepParamURL}
                          wizardData={wizardData}
                          steps={steps}
                        />
                      </div>
                    )}
                    {steps && stepIndex > 0 && stepIndex < steps.length && (
                      <div className="mt-md-4">
                        {stepParamURL && stepParamURL !== "1" && (
                          <StepOptions
                            match={match}
                            history={history}
                            location={location}
                            stepParamURL={stepParamURL}
                            steps={steps}
                            wizardData={wizardData}
                          />
                        )}
                        <div className=" mt-md-5">
                          {steps && stepIndex > 0 && stepIndex < steps.length && (
                            <div>
                              {stepParamURL && (
                                <button
                                  type="button"
                                  className="d-md-none d-xs-block w-100 btn btn-red btn-next-step d-none d-md-block w-100"
                                  onClick={() => {
                                    this.handleStepParam(stepParamURL);
                                    Event(
                                      "STEP",
                                      `Usuario dió click en ir a paso ${parseInt(
                                        stepParamURL
                                      ) + 1}`,
                                      "STEP_INDEX"
                                    );
                                  }}
                                >
                                  Paso siguiente
                                </button>
                              )}
                              {stepParamURL && (
                                <button
                                  type="button"
                                  className="d-md-none d-xs-block w-100 btn btn-red btn-next-step button-next-xs"
                                  onClick={() => {
                                    this.handleStepParam(stepParamURL);
                                    Event(
                                      "STEP",
                                      `Usuario dió click en ir a paso ${parseInt(
                                        stepParamURL
                                      ) + 1}`,
                                      "STEP_INDEX"
                                    );
                                  }}
                                >
                                  Paso siguiente
                                </button>
                              )}
                            </div>
                          )}
                        </div>
                        {steps && stepIndex > 0 && stepIndex < steps.length && (
                          <Features route={this.props} />
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Home;
